import StorageBaseClass from './StorageBaseClass'

export default new StorageBaseClass('UFP')
